export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13197.9d4825b6.jpg";